/* ═══════════════════════════════════════════════════════════════
   WuZuo Alice — Ritual V1: GSAP + Interactions
   Loaded conditionally on page.ritual-v1 template only
   ═══════════════════════════════════════════════════════════════ */
(function() {
  'use strict';

  /* ── Wait for GSAP + ScrollTrigger to load ── */
  function waitForGSAP(cb) {
    if (window.gsap && window.ScrollTrigger) return cb();
    setTimeout(function() { waitForGSAP(cb); }, 100);
  }

  waitForGSAP(function() {
    gsap.registerPlugin(ScrollTrigger);

    /* ══════════════════════════════════════════════
       1. OPENING RITUAL — Word injection + scroll timeline
       ══════════════════════════════════════════════ */
    var line1El = document.getElementById('openingLine1');
    var line2El = document.getElementById('openingLine2');

    if (line1El && line2El) {
      var line1Text = line1El.getAttribute('data-text') || 'Every flame begins with intention.';
      var line2Text = line2El.getAttribute('data-text') || 'The fire does not create your desire — it reveals it.';

      function injectWords(el, text) {
        var words = text.split(' ');
        el.innerHTML = '';
        words.forEach(function(w) {
          var span = document.createElement('span');
          span.className = 'rv1-opening__word';
          span.textContent = w;
          el.appendChild(span);
        });
      }
      injectWords(line1El, line1Text);
      injectWords(line2El, line2Text);

      var allWords = document.querySelectorAll('.rv1-opening__word');
      var subEl = document.getElementById('openingSub');
      var glowEl = document.getElementById('candleGlow');
      var cssFlameEl = document.getElementById('cssFlame');

      var openingSection = document.getElementById('opening');
      if (openingSection) {
        var tl = gsap.timeline({
          scrollTrigger: {
            trigger: openingSection,
            start: 'top top',
            end: 'bottom bottom',
            scrub: 1,
            onUpdate: function(self) {
              var progress = self.progress;
              if (cssFlameEl) {
                var s = 0.6 + progress * 0.8;
                cssFlameEl.style.transform = 'scale(' + s + ')';
                cssFlameEl.style.opacity = 0.5 + progress * 0.5;
              }
              if (glowEl) {
                glowEl.style.opacity = progress * 0.8;
              }
            }
          }
        });

        allWords.forEach(function(word, i) {
          tl.to(word, {
            opacity: 1,
            y: 0,
            duration: 0.05,
            ease: 'power2.out'
          }, i * 0.03);
        });

        if (subEl) {
          tl.to(subEl, {
            opacity: 0.8,
            y: 0,
            duration: 0.1,
            ease: 'power2.out'
          }, '>-0.05');
        }

        tl.to('.rv1-opening__scroll-hint', {
          opacity: 0,
          duration: 0.05
        }, 0);
      }
    }

    /* ══════════════════════════════════════════════
       2. TWO PATHS — Entrance animation
       ══════════════════════════════════════════════ */
    var twoPaths = document.getElementById('two-paths');
    if (twoPaths) {
      gsap.from('.rv1-paths__panel--wicca', {
        x: '-100%',
        opacity: 0,
        duration: 1.2,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: twoPaths,
          start: 'top 80%',
          toggleActions: 'play none none none'
        }
      });
      gsap.from('.rv1-paths__panel--classical', {
        x: '100%',
        opacity: 0,
        duration: 1.2,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: twoPaths,
          start: 'top 80%',
          toggleActions: 'play none none none'
        }
      });
    }

    /* ══════════════════════════════════════════════
       3. WHEEL OF THE YEAR — Sabbat data + SVG + scroll
       ══════════════════════════════════════════════ */
    var wheelSvg = document.getElementById('wheelSvg');
    if (wheelSvg) {
      /* Read sabbat data from Liquid-rendered JSON (theme editor configurable) */
      var sabbatDataEl = document.getElementById('wheelSabbatData');
      var sabbats = sabbatDataEl ? JSON.parse(sabbatDataEl.textContent) : [];

      var wheelGroup = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      wheelGroup.id = 'wheelPoints';
      wheelSvg.appendChild(wheelGroup);

      sabbats.forEach(function(s, i) {
        var rad = (s.angle - 90) * Math.PI / 180;
        var x = 200 + 170 * Math.cos(rad);
        var y = 200 + 170 * Math.sin(rad);
        var lx = 200 + 195 * Math.cos(rad);
        var ly = 200 + 195 * Math.sin(rad);

        var g = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        g.setAttribute('class', 'rv1-wheel__point' + (i === 0 ? ' rv1-wheel__point--active' : ''));
        g.setAttribute('data-idx', i);

        var circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        circle.setAttribute('class', 'rv1-wheel__dot');
        circle.setAttribute('cx', x);
        circle.setAttribute('cy', y);
        circle.setAttribute('r', i === 0 ? '8' : '5');
        circle.setAttribute('fill', '#c9a84c');
        circle.setAttribute('opacity', i === 0 ? '1' : '0.4');
        g.appendChild(circle);

        var label = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        label.setAttribute('class', 'rv1-wheel__point-label');
        label.setAttribute('x', lx);
        label.setAttribute('y', ly + 3);
        label.setAttribute('text-anchor', 'middle');
        label.setAttribute('fill', '#6b5d54');
        label.setAttribute('font-family', "'Space Mono', monospace");
        label.setAttribute('font-size', '9');
        label.setAttribute('letter-spacing', '0.15em');
        label.textContent = s.name;
        g.appendChild(label);

        g.addEventListener('click', function() { showSabbat(i); });
        wheelGroup.appendChild(g);
      });

      var currentSabbat = 0;
      function showSabbat(idx) {
        currentSabbat = idx;
        var s = sabbats[idx];
        var nameEl = document.getElementById('wheelName');
        var dateEl = document.getElementById('wheelDate');
        var descEl = document.getElementById('wheelDesc');
        if (nameEl) nameEl.textContent = s.name;
        if (dateEl) dateEl.textContent = s.date;
        if (descEl) descEl.textContent = s.desc;
        document.querySelectorAll('.rv1-wheel__point').forEach(function(p, i) {
          p.classList.toggle('rv1-wheel__point--active', i === idx);
          var dot = p.querySelector('.rv1-wheel__dot');
          if (dot) {
            dot.setAttribute('r', i === idx ? '8' : '5');
            dot.setAttribute('opacity', i === idx ? '1' : '0.4');
          }
          var lbl = p.querySelector('.rv1-wheel__point-label');
          if (lbl) lbl.setAttribute('fill', i === idx ? '#c9a84c' : '#6b5d54');
        });
      }

      var wheelSection = document.getElementById('wheelSection');
      if (wheelSection) {
        ScrollTrigger.create({
          trigger: wheelSection,
          start: 'top center',
          end: 'bottom center',
          onUpdate: function(self) {
            var idx = Math.floor(self.progress * sabbats.length);
            idx = Math.min(idx, sabbats.length - 1);
            if (idx !== currentSabbat) showSabbat(idx);
            var rotation = self.progress * 360;
            wheelGroup.setAttribute('transform', 'rotate(' + rotation + ' 200 200)');
            document.querySelectorAll('.rv1-wheel__point-label').forEach(function(lbl) {
              var cx = lbl.getAttribute('x');
              var cy = lbl.getAttribute('y');
              lbl.setAttribute('transform', 'rotate(' + (-rotation) + ' ' + cx + ' ' + cy + ')');
            });
          }
        });
      }
    }

    /* ══════════════════════════════════════════════
       4. CHAPTER HERO — Entrance animations
       ══════════════════════════════════════════════ */
    gsap.utils.toArray('.rv1-chapter-hero').forEach(function(hero) {
      var sym = hero.querySelector('.rv1-chapter-hero__symbol');
      var lbl = hero.querySelector('.rv1-chapter-hero__label');
      var rule = hero.querySelector('.rv1-chapter-hero__rule');
      var ttl = hero.querySelector('.rv1-chapter-hero__title');
      var desc = hero.querySelector('.rv1-chapter-hero__desc');
      var htl = gsap.timeline({
        scrollTrigger: { trigger: hero, start: 'top 75%', toggleActions: 'play none none none' }
      });
      if (sym) htl.from(sym, { opacity: 0, scale: 0.6, duration: 0.8, ease: 'back.out(1.4)' });
      if (lbl) htl.from(lbl, { opacity: 0, y: 15, duration: 0.5, ease: 'power2.out' }, '-=0.3');
      if (rule) htl.from(rule, { scaleX: 0, opacity: 0, duration: 0.5, ease: 'power2.out' }, '-=0.2');
      if (ttl) htl.from(ttl, { opacity: 0, y: 20, duration: 0.6, ease: 'power2.out' }, '-=0.2');
      if (desc) htl.from(desc, { opacity: 0, y: 15, duration: 0.5, ease: 'power2.out' }, '-=0.2');
    });

    /* ══════════════════════════════════════════════
       5. WICCA / CLASSICAL — Batch reveal
       ══════════════════════════════════════════════ */
    gsap.utils.toArray('.rv1-moon, .rv1-color, .rv1-sub__label, .rv1-sub__title').forEach(function(el) {
      gsap.from(el, {
        opacity: 0, y: 20, duration: 0.6, ease: 'power2.out',
        scrollTrigger: { trigger: el, start: 'top 85%', toggleActions: 'play none none none' }
      });
    });

    gsap.utils.toArray('.rv1-planet, .rv1-solomon, .rv1-hours-table tr').forEach(function(el, i) {
      gsap.from(el, {
        opacity: 0, y: 20, duration: 0.6, delay: i * 0.03, ease: 'power2.out',
        scrollTrigger: { trigger: el, start: 'top 88%', toggleActions: 'play none none none' }
      });
    });

    /* ══════════════════════════════════════════════
       6. SIGIL — Scroll-driven stroke drawing
       ══════════════════════════════════════════════ */
    var sigilPath = document.getElementById('sigilPath');
    var sigilSection = document.getElementById('sigilSection');
    if (sigilPath && sigilSection) {
      var pathLength = sigilPath.getTotalLength();
      sigilPath.style.strokeDasharray = pathLength;
      sigilPath.style.strokeDashoffset = pathLength;

      gsap.to(sigilPath, {
        strokeDashoffset: 0,
        ease: 'none',
        scrollTrigger: {
          trigger: sigilSection,
          start: 'top 60%',
          end: 'bottom 40%',
          scrub: 1
        }
      });
    }

    /* ══════════════════════════════════════════════
       7. RITUAL STEPS — Scroll-driven step switching
       ══════════════════════════════════════════════ */
    var steps = document.querySelectorAll('.rv1-step');
    var stepDots = document.querySelectorAll('.rv1-steps__dot');
    var stepsGlow = document.getElementById('stepsGlow');
    var ritualSteps = document.getElementById('ritualSteps');

    if (steps.length && ritualSteps) {
      var currentStep = 0;
      var stepGlows = [
        'radial-gradient(circle, rgba(120,180,100,0.6) 0%, rgba(80,140,60,0.15) 50%, transparent 75%)',
        'radial-gradient(circle, rgba(201,168,76,0.6) 0%, rgba(180,150,50,0.15) 50%, transparent 75%)',
        'radial-gradient(circle, rgba(180,120,220,0.6) 0%, rgba(140,80,180,0.15) 50%, transparent 75%)',
        'radial-gradient(circle, rgba(255,160,60,0.7) 0%, rgba(220,120,30,0.2) 50%, transparent 75%)',
        'radial-gradient(circle, rgba(100,150,240,0.55) 0%, rgba(60,100,200,0.15) 50%, transparent 75%)',
        'radial-gradient(circle, rgba(255,220,100,0.65) 0%, rgba(220,180,60,0.2) 50%, transparent 75%)'
      ];

      ScrollTrigger.create({
        trigger: ritualSteps,
        start: 'top top',
        end: 'bottom bottom',
        onUpdate: function(self) {
          var idx = Math.floor(self.progress * steps.length);
          idx = Math.min(idx, steps.length - 1);
          if (idx !== currentStep) {
            steps[currentStep].classList.remove('rv1-step--active');
            if (stepDots[currentStep]) stepDots[currentStep].classList.remove('rv1-steps__dot--active');
            currentStep = idx;
            steps[currentStep].classList.add('rv1-step--active');
            if (stepDots[currentStep]) stepDots[currentStep].classList.add('rv1-steps__dot--active');
            if (stepsGlow && stepGlows[idx]) stepsGlow.style.background = stepGlows[idx];
          }
        }
      });
    }

    /* ══════════════════════════════════════════════
       8. BRIDGE + PRODUCTS + CTA — Entrance animations
       ══════════════════════════════════════════════ */
    var bridge = document.getElementById('bridge');
    if (bridge) {
      gsap.from('.rv1-bridge__content', {
        opacity: 0, y: 40, duration: 1, ease: 'power2.out',
        scrollTrigger: { trigger: bridge, start: 'top 70%', toggleActions: 'play none none none' }
      });
    }

    var products = document.getElementById('products');
    if (products) {
      gsap.utils.toArray('.rv1-product').forEach(function(el, i) {
        gsap.from(el, {
          opacity: 0, y: 30, duration: 0.6, delay: i * 0.08, ease: 'power2.out',
          scrollTrigger: { trigger: products, start: 'top 70%', toggleActions: 'play none none none' }
        });
      });
    }

    var cta = document.getElementById('cta');
    if (cta) {
      gsap.from('.rv1-cta__title', {
        opacity: 0, y: 30, duration: 1, ease: 'power2.out',
        scrollTrigger: { trigger: cta, start: 'top 75%', toggleActions: 'play none none none' }
      });
    }

    /* ══════════════════════════════════════════════
       9. PRODUCT TAB FILTERING
       ══════════════════════════════════════════════ */
    var tabs = document.querySelectorAll('.rv1-products__tab');
    var productCards = document.querySelectorAll('.rv1-product');
    if (tabs.length && productCards.length) {
      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          tabs.forEach(function(t) { t.classList.remove('rv1-products__tab--active'); });
          tab.classList.add('rv1-products__tab--active');
          var filter = tab.dataset.filter;
          productCards.forEach(function(p) {
            if (filter === 'all' || p.dataset.collection === filter) {
              gsap.to(p, { opacity: 1, scale: 1, duration: 0.4, display: 'block' });
            } else {
              gsap.to(p, { opacity: 0, scale: 0.95, duration: 0.3, display: 'none' });
            }
          });
        });
      });
    }

    /* ══════════════════════════════════════════════
       10. MOON PHASE CALCULATION (real-time)
       ══════════════════════════════════════════════ */
    try {
      (function() {
        var synodicMonth = 29.53059;
        var knownNewMoon = new Date(2026, 1, 28, 0, 45);
        var now = new Date();
        var daysSince = (now - knownNewMoon) / (1000 * 60 * 60 * 24);
        var phase = ((daysSince % synodicMonth) + synodicMonth) % synodicMonth;
        var phaseRatio = phase / synodicMonth;

        var phaseName;
        if (phaseRatio < 0.0625) { phaseName = 'New Moon'; }
        else if (phaseRatio < 0.1875) { phaseName = 'Waxing Crescent'; }
        else if (phaseRatio < 0.3125) { phaseName = 'First Quarter'; }
        else if (phaseRatio < 0.4375) { phaseName = 'Waxing Gibbous'; }
        else if (phaseRatio < 0.5625) { phaseName = 'Full Moon'; }
        else if (phaseRatio < 0.6875) { phaseName = 'Waning Gibbous'; }
        else if (phaseRatio < 0.8125) { phaseName = 'Last Quarter'; }
        else if (phaseRatio < 0.9375) { phaseName = 'Waning Crescent'; }
        else { phaseName = 'New Moon'; }

        var daysToFull = Math.round((0.5 - phaseRatio) * synodicMonth);
        if (daysToFull < 0) daysToFull += Math.round(synodicMonth);
        if (daysToFull === 0) daysToFull = 'Tonight is';

        var phaseEl = document.getElementById('ctaMoonPhase');
        var countEl = document.getElementById('ctaCountdown');
        var moonShadow = document.getElementById('ctaMoonShadow');
        if (phaseEl) phaseEl.textContent = phaseName;
        if (countEl) countEl.textContent = (daysToFull === 'Tonight is') ? 'Tonight is the Full Moon — maximum ritual power' : daysToFull + ' days until Full Moon';

        if (moonShadow) {
          var cx = 60, cy = 60, r = 50;
          var illumination = phaseRatio <= 0.5 ? phaseRatio * 2 : (1 - phaseRatio) * 2;
          var tx = (illumination - 0.5) * 2 * r;

          if (illumination > 0.99) {
            moonShadow.setAttribute('d', '');
          } else if (illumination < 0.01) {
            moonShadow.setAttribute('d', 'M60,10 A50,50 0 1,1 60,110 A50,50 0 1,1 60,10 Z');
          } else if (phaseRatio <= 0.5) {
            var d = 'M' + cx + ',' + (cy - r) +
                    ' A' + r + ',' + r + ' 0 0,0 ' + cx + ',' + (cy + r) +
                    ' A' + Math.abs(tx) + ',' + r + ' 0 0,' + (tx < 0 ? '0' : '1') + ' ' + cx + ',' + (cy - r) + ' Z';
            moonShadow.setAttribute('d', d);
          } else {
            var d = 'M' + cx + ',' + (cy - r) +
                    ' A' + r + ',' + r + ' 0 0,1 ' + cx + ',' + (cy + r) +
                    ' A' + Math.abs(tx) + ',' + r + ' 0 0,' + (tx < 0 ? '1' : '0') + ' ' + cx + ',' + (cy - r) + ' Z';
            moonShadow.setAttribute('d', d);
          }
        }
      })();
    } catch(e) { console.warn('Moon phase error:', e); }

    /* ══════════════════════════════════════════════
       11. MOBILE SWIPE INDICATORS (Two Paths)
       ══════════════════════════════════════════════ */
    var pathsSection = document.getElementById('two-paths');
    var pathsDots = document.querySelectorAll('.rv1-paths__indicator');
    if (pathsSection && pathsDots.length) {
      pathsSection.addEventListener('scroll', function() {
        var scrollLeft = pathsSection.scrollLeft;
        var panelWidth = pathsSection.scrollWidth / 2;
        var idx = Math.round(scrollLeft / panelWidth);
        pathsDots.forEach(function(d, i) {
          d.classList.toggle('rv1-paths__indicator--active', i === idx);
        });
      });
    }

  }); /* end waitForGSAP */
})();